import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import {
    HandIcon,
    HandsIcon,
    SupportIcon,
    EditProfileIcon,
} from '../../../../../assets/icons';

interface Props {
    postNewJob: () => void;
};

function WelcomeBox(props: Props) {
    const { postNewJob } = props;

    return (
        <div className={styles.container}>
            <span className={styles.header}>Welcome to MeritFinder</span>
            <div className={styles.content}>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><EditProfileIcon /></div>
                    <span className={styles.content_item_text}>
                        Post the job description
                    </span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><HandIcon /></div>
                    <span className={styles.content_item_text}>
                        Generate interviews and tests<br /> based on job postings
                    </span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><SupportIcon /></div>
                    <span className={styles.content_item_text}>
                        Applicants will be<br /> interviewed and tested
                    </span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><HandsIcon /></div>
                    <span className={styles.content_item_text}>
                        Analyze all applicants and AI<br /> feedback to find the best talent
                    </span>
                </div>
            </div>
            <Button
                text='+ Post New Job'
                onClick={postNewJob}
                className={styles.CTA}
            />
        </div>
    );
};

export default WelcomeBox;
